<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading$ | async">
  <mic-breadcrumb id="view-cam-spec-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/specifications" label="{{ translationService.translate('camSpecsText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="" label="{{ translationService.translate('camSpecDetailsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  @if (specification) {
  <div class="view-edit-cam-specification mt-3">
    <form [formGroup]="camSpecificationForm">
      <div class="w-full flex flex-row items-center justify-between">
        <div class="justify-self-start">
          <h2 class="m-0" id="cam-spec-details-heading">{{ translationService.translate('camSpecDetailsText') }}</h2>
        </div>

        <div class="view-edit-spec-button-container">
          <button
            id="export-button"
            mat-flat-button
            color="primary"
            style="margin-right: 14px; margin-top: 2px"
            (click)="export()"
            disabled="{{ editMode }}"
          >
            <mat-icon>download</mat-icon>
            <span>{{ translationService.translate('exportText') }}</span>
          </button>
          @if (hasEditPermission) {
          <button
            id="add-line-button"
            mat-flat-button
            color="primary"
            style="margin-right: 14px; margin-top: 2px"
            (click)="addLineButtonClick()"
            disabled="{{ editMode }}"
          >
            <mat-icon>add</mat-icon>
            {{ translationService.translate('addLineButtonText') }}
          </button>
          }
        </div>
      </div>

      <mat-card class="custom-card-no-shadow mt-5 {{ textFieldClass }}" appearance="outlined">
        <div class="w-full flex flex-row items-center justify-between gap-3">
          <div class="justify-self-start gap-3 px-5 py-2">
            <mat-form-field class="mr-5" subscriptSizing="dynamic" id="cam-spec-name-field">
              <mat-label>{{ translationService.translate('camSpecNameText') }}</mat-label>
              <input matInput type="text" placeholder="" [formControlName]="'name'" required readonly />
              @if (camSpecificationForm.get('name').hasError('required')) {
              <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="mr-5" subscriptSizing="dynamic" id="cam-spec-description-field">
              <mat-label>{{ translationService.translate('camSpecDescText') }}</mat-label>
              <input
                matInput
                type="text"
                placeholder=""
                [formControlName]="'description'"
                required
                [readonly]="!isEditCamDesciptionEnabled"
              />
              @if (!isEditCamDesciptionEnabled && hasEditPermission) {
              <button id="edit-icon" (click)="onDescEditClick()" mat-icon-button matSuffix>
                <mat-icon>edit</mat-icon>
              </button>
              } @if (isEditCamDesciptionEnabled) {
              <button id="check-icon" (click)="onDescSaveClick()" mat-icon-button matSuffix>
                <mat-icon>check</mat-icon>
              </button>
              } @if (isEditCamDesciptionEnabled) {
              <button id="clear-icon" (click)="onCancelDescEditClick()" mat-icon-button matSuffix>
                <mat-icon>clear</mat-icon>
              </button>
              } @if (camSpecificationForm.get('description').hasError('required')) {
              <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="mr-5" subscriptSizing="dynamic" id="cam-spec-type-field">
              <mat-label>{{ translationService.translate('camSpecTypeText') }}</mat-label>
              <input matInput type="text" placeholder="" [formControlName]="'type'" required readonly />
              @if (camSpecificationForm.get('type').hasError('required')) {
              <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="flex">
            @if (isActive) {
            <mic-status class="active-status-tag valid">{{ translationService.translate('activeText') }}</mic-status>
            } @if (!isActive) {
            <mat-chip class="inactive-status-tag px-2" disableRipple color="secondary">{{
              translationService.translate('inactiveText')
            }}</mat-chip>
            }
          </div>
        </div>
      </mat-card>

      <mat-card class="custom-card-no-shadow view-edit-cam-mat-card mt-5" appearance="outlined">
        <div class="max-h-full">
          <mic-sidebar-container class="flex flex-row" leftToggler="cam-spec-line-toggler">
            <mic-sidebar position="start" mode="large">
              @for (specificationLine of specification.specificationLines; track specificationLine; let i = $index) {
              <mic-sidebar-item
                [id]="'spec-line-label-' + i"
                class="spec-line-label"
                [link]="specificationLink(specificationLine.id)"
                [label]="
                  specificationLine.label === 'Default RR'
                    ? translationService.translate('defaultRRText')
                    : specificationLine.label === 'Default RO'
                    ? translationService.translate('defaultROText')
                    : specificationLine.label
                "
                [ngClass]="{ 'spec-line-label': true, 'disable-sidebar': editMode === true }"
                (keydown.enter)="disable_key_sidebar($event)"
              >
              </mic-sidebar-item>
              }
            </mic-sidebar>
            <mic-main-content main>
              <div id="spec-line" class="flex flex-col fill justify-between" content>
                <!-- Toggler only appears at mobile breakpoints; lets users open the
                     spec-line list so the line detail can use full width. -->
                <mic-sidebar-toggler id="cam-spec-line-toggler" [alwaysDisplay]="false" class="mb-2"></mic-sidebar-toggler>
                <mat-card class="custom-card-no-shadow view-edit-cam-line-mat-card">
                  @if (specification.specificationLines?.length) {
                  <router-outlet></router-outlet>
                  } @else {
                  <div class="p-5 text-center" id="no-spec-lines-message">
                    {{ translationService.translate('noSpecificationLinesText') }}
                  </div>
                  }
                </mat-card>
              </div>
            </mic-main-content>
          </mic-sidebar-container>
        </div>
      </mat-card>
    </form>
  </div>
  }
</mic-spinner-overlay>
